import { useQuery } from '@tanstack/react-query';
import { getSidebarCounters } from '@/services/sidebarCountersService';

export const sidebarCountersKey = ['sidebar-counters'] as const;

export function useSidebarCounters() {
  return useQuery({
    queryKey: sidebarCountersKey,
    queryFn: getSidebarCounters,
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}
